"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const valueIsUndefinedOr_1 = __importDefault(require("../../typeAssertions/valueIsUndefinedOr"));
const callableConfirmationAlert = ({ callbacks, executeProcesses, entryVars: { title, subtitle, acceptText, cancelText, }, processor, }) => {
    if (!(0, valueIsUndefinedOr_1.default)(valueIsString_1.default)(acceptText)) {
        processor.root.alert('Error', 'The acceptText should be an string');
        return;
    }
    if (!(0, valueIsUndefinedOr_1.default)(valueIsString_1.default)(cancelText)) {
        processor.root.alert('Error', 'The cancelText should be an string');
        return;
    }
    const newTitle = (0, valueIsString_1.default)(title) ? title : JSON.stringify(title);
    const newSubtitle = (0, valueIsString_1.default)(subtitle) ? subtitle : JSON.stringify(subtitle);
    const handleClose = (callback) => () => {
        processor.root.openConfirmAlert({
            isOpened: false,
            title: '',
            description: '',
            onOkText: '',
            onCancelText: '',
            onOk: undefined,
            onCancel: undefined,
        });
        callback();
    };
    processor.root.openConfirmAlert({
        isOpened: true,
        title: newTitle,
        description: newSubtitle,
        onOkText: acceptText || 'Accept',
        onCancelText: cancelText || 'Cancel',
        onOk: handleClose(() => executeProcesses(undefined, callbacks.onAccept)),
        onCancel: handleClose(() => executeProcesses(undefined, callbacks.onCancel)),
    });
};
exports.default = callableConfirmationAlert;
